import * as React from "react";
import {Form, Row, Col} from "react-bootstrap";
import Select from "../../../../components/select";
import {Link} from "react-router-dom";


export default ({props, contractors, newContractor, selectContractor, selectedContractors, removeContractor}) => (
    <div> 
        <div className="d-flex align-items-center">
            <div>
                <h5>Assign contractors</h5>
                <p className="text-muted">Assign contractors to your project</p>
            </div>
            <div>
                <i className="fas fa-user-plus" />
            </div>
        </div>

        <p className="font-weight-bold">Assgined contractors</p>

        <div className="my-3">
            <p>Contractor</p>
            {
                selectedContractors.map((contractor, index) => (
                    <div className="selected-contractor my-1 d-flex align-items-center justify-content-between">
                        <div>
                            <p key={index}>{contractor.name}</p>
                        </div>
                        <div>
                            <i className="fas fa-trash mx-3" onClick={() => removeContractor(contractor)} />
                            <Link to="/contractors">
                                <i className="fas fa-info mx-3" />
                            </Link>
                        </div>
                    </div>
                ))
            }
        </div>

        <Select 
            contractors={contractors} 
            add={() => newContractor()}
            select={(contractor) => selectContractor(contractor)}
        />


    </div>
)